import React, { useState, useEffect } from "react";
import images from "../../../Utils/importImages";

function TravellersHeader({ setAddTraveller, addTraveller, setSearchTerm }) {
  let [searchText, setSearchText] = useState("");

  // Debounce search input to optimize performance
  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setSearchTerm(searchText);
    }, 300); // 300ms delay

    return () => clearTimeout(delaySearch); // Cleanup function
  }, [searchText, setSearchTerm]);

  return (
    <div className="internal-tab-head">
      <div className="add-traveller-head">
        <h3>Travellers Details</h3>
        {!addTraveller && (
          <div className="filter-addbutton">
            <div className="filter-search">
              <input
                type="text"
                placeholder="Search by name"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div
              className="add-travellers-button"
              onClick={() => setAddTraveller(true)}
            >
              <img src={images["addtraveller-ico.svg"]} alt="" />
              Add Traveller
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TravellersHeader;
